import { doc_spec, languageMap } from '../../utils/sharepoint';
import { getRequest } from './functions';
import { AREAS, getLineLabel } from '../../config/roasterySpec';
import { buildDeliveryNoteSerialLines } from './deliveryNoteSerials.mjs';

export const getCompanyName = (companyName) => companyName.replace('&', '%26');
const encode = (string) => (string ? encodeURIComponent(string) : '');

export const DeliveryToInvoice = async (delivery, lines, company, lineInterface, setIsTransforming, navigate) => {
  setIsTransforming(true);

  for (var i = 0; i < lines.length; i++) {
    let sellingPrice = 0;
    const line = lines[i];
    if (line.produktnr) {
      const productData = await getRequest(`/api/products/${line.produktnr}`);
      sellingPrice = productData['Eenheids verkoopprijs'];
    }
    lines[i].VP = sellingPrice || 0;
  }

  const newLines = [
    {
      ...lineInterface,
      Lijnnr: null,
      aantal: null,
      VP: null,
      BTW: 0,
      faktuurnr: 'new',
      produktnr: 1,
      tekstlijn: `${doc_spec['delivery_note'].lan[languageMap[delivery.TaalID]] || 'Delivery note'} N° ${delivery.LeveringsbonNummer} dd ${String(delivery.datum).substring(0, 10)}`
    },
    ...lines.map((line) => ({
      ...line,
      Lijnnr: null,
      faktuurnr: 'new',
      aantal: line.aantalgeleverd || 0,
      BTW: parseInt(company.LandID) === 300 ? 21 : 0
    }))
  ];

  let specificUrl = '';
  let confirmed = true;
  const queryUrl = `&btwnummer=${company.BTW}&TaalID=${company.TaalID}&betalingID=${company.betalingID}&isDirty=true&linesDirty=true&refklant=${encode(delivery.refklant)}`;
  if (company.FirNrFactuur) {
    //get seperate invoicing company from api
    const invoicingCompany = await getRequest(`/api/companies/${company.FirNrFactuur}`);
    let invoicingCompanyName = invoicingCompany.NAAM.replace('&', '%26');
    if (window.confirm(`ATTENTION: This company has a separate invoicing address, this will create an invoice on ${invoicingCompanyName}`)) {
      specificUrl = `?klantnummer=${invoicingCompany.FIRNR}&klantnaam=${invoicingCompanyName}&adres=${invoicingCompany.STRAAT_NR}&postkode=${invoicingCompany.POSTNR}&woonplaats=${invoicingCompany.WOONPL}&LandID=${invoicingCompany.LandID}`;
    } else {
      confirmed = false;
    }
  } else {
    let companyName = company.NAAM.replace('&', '%26');
    specificUrl = `?klantnummer=${company.FIRNR}&klantnaam=${companyName}&adres=${company.STRAAT_NR}&postkode=${company.POSTNR}&woonplaats=${company.WOONPL}&LandID=${company.LandID}`;
  }

  if (!confirmed) return;

  navigate({ pathname: `/invoices/new`, search: `${specificUrl}${queryUrl}` }, { state: newLines });

  setIsTransforming(false);
};

export const InquiryToPurchase = async (inquiry, lines, company, lineInterface, navigate, copyDocumentIds = []) => {
  // BestellingLijn.PrijsaanvraagID links the order to the inquiry: the inquiry lifecycle derives "Ordered" from it
  const inquiryLink = { PrijsaanvraagID: inquiry.PrijsaanvraagID };
  const machineLine =
    inquiry.MachineType || inquiry.MachineNummer
      ? {
          ...lineInterface,
          Lijnnr: null,
          aantal: null,
          VP: null,
          faktuurnr: 'new',
          produktnr: 1,
          ...inquiryLink,
          tekstlijn: `${inquiry.MachineType && `Machine Type: ${inquiry.MachineType}`} ${inquiry.MachineNummer && `N° ${inquiry.MachineNummer}`} `
        }
      : null;

  const newLines = [
    {
      ...lineInterface,
      BestellingLijnID: null,
      aantal: null,
      VP: null,
      BestellingID: 'new',
      produktnr: 1,
      ...inquiryLink,
      tekstlijn: `${doc_spec['price_request'].lan[languageMap[inquiry.TaalID]]} N° ${inquiry.Prijsaanvraagnummer} (${String(inquiry.Datum).substring(0, 10)})`
    },
    machineLine,
    ...lines.map((line) => ({ ...line, BestellingLijnID: null, BestellingID: 'new', ...inquiryLink }))
  ];

  navigate(
    {
      pathname: `/purchases/new`,
      search: `?LeverancierID=${company.FIRNR}&TaalID=${company.TaalID}&LandID=${company.LandID}&KlantID=${inquiry.KlantID || ''}&LeveringKlantID=${
        inquiry.LeveringKlantID || ''
      }&isDirty=true&linesDirty=true${inquiry.ProjectID ? `&ProjectID=${inquiry.ProjectID}` : ''}&RefKlant=${encode(inquiry.RefKlant)}&RefKlantDatum=${inquiry.RefKlantDatum || ''}&MachineType=${
        inquiry.MachineType || ''
      }&MachineNummer=${inquiry.MachineNummer || ''}${
        // the purchase page copies these inquiry files once the new order is saved
        copyDocumentIds.length ? `&copyFromInquiryID=${inquiry.PrijsaanvraagID}&copyDocumentIDs=${copyDocumentIds.join(',')}` : ''
      }`
    },
    { state: newLines.filter((line) => line) }
  );
};

export const InvoiceToCreditnote = async (invoice, lines, company, lineInterface, navigate) => {
  /*
          if invoicing address is different, then invoice on correct address
          should also expose a lot of variables that are not exposed by the frontend
          such as the address, zip code, city, country, etc.
          This are fields that are copied from the company info. 
        */

  //tranform the lines object to adhere to the invoice lines object
  const newLines = [
    {
      ...lineInterface,
      CreditnotaLijnID: null,
      aantal: null,
      VP: null,
      CreditnotaID: 'new',
      produktnr: 1,
      tekstlijn: `${doc_spec['invoice'].lan[languageMap[invoice.TaalID]]} N° ${invoice.Factuurnummer} (${String(invoice.datum).substring(0, 10)})`
    },
    ...lines.map((line) => ({ ...line, CreditnotaLijnID: null, CreditnotaID: 'new' }))
  ];

  const queryUrl = `&FIRNR=${company.FIRNR}&FactuurID=${invoice.faktuurnr}&TaalID=${company.TaalID}&FIRNR=${company.FIRNR}&isDirty=true&linesDirty=true&BedragOpen=${
    invoice.totaalbedrag
  }&BedragTotaal=${invoice.totaalbedrag}&Referentie=${encode(invoice.refklant)}`;

  navigate({ pathname: `/creditnotes/new`, search: `${queryUrl}` }, { state: newLines });
};

export const SaleToInvoice = async (sale, lines, company, lineInterface, navigate) => {
  /*
            if invoicing address is different, then invoice on correct address
            should also expose a lot of variables that are not exposed by the frontend
            such as the address, zip code, city, country, etc.
            This are fields that are copied from the company info. 
          */

  //tranform the lines object to adhere to the invoice lines object
  const machineLine =
    sale.MachineType || sale.MachineNummer
      ? {
          ...lineInterface,
          Lijnnr: null,
          aantal: null,
          VP: null,
          faktuurnr: 'new',
          produktnr: 1,
          tekstlijn: `${sale.MachineType && `Machine Type: ${sale.MachineType}`} ${sale.MachineNummer && `N° ${sale.MachineNummer}`} `
        }
      : null;

  const newLines = [
    {
      ...lineInterface,
      Lijnnr: null,
      aantal: null,
      VP: null,
      faktuurnr: 'new',
      produktnr: 1,
      tekstlijn: `${doc_spec['order_confirmation'].lan[languageMap[sale.TaalID]]} N° ${sale.Orderbevestigingnummer} (${String(sale.Datum).substring(0, 10)})`
    },
    machineLine,
    ...lines.map((line) => ({
      ...line,
      Lijnnr: null,
      faktuurnr: 'new',
      DiscountCode: line.DiscountCode || null // Preserve discount code when transforming sale to invoice
    }))
  ];

  let specificUrl = '';
  let confirmed = true;
  const queryUrl = `&TaalID=${company.TaalID}&betalingID=${company.betalingID}&isDirty=true&linesDirty=true&OrderbevestigingID=${sale.OrderbevestigingID}${
    sale.ProjectID ? `&ProjectID=${sale.ProjectID}` : '' + sale.RefKlant === null || !sale.RefKlant ? '' : `&refklant=${encode(sale.RefKlant)}`
  }&LeveringKlantID=${sale.LeveringKlantID || ''}`;
  if (!company.FirNrFactuur && !company.BTW) {
    if (window.confirm(`ATTENTION: This customer has no VAT number. Do you want to continue?`)) {
      let companyName = company.NAAM.replace('&', '%26');
      specificUrl = `?klantnummer=${company.FIRNR}&klantnaam=${companyName}&adres=${company.STRAAT_NR}&postkode=${company.POSTNR}&woonplaats=${company.WOONPL}&LandID=${company.LandID}`;
    }
  }
  if (company.FirNrFactuur) {
    //get seperate invoicing company from api
    const invoicingCompany = await getRequest(`/api/companies/${company.FirNrFactuur}`);
    let invoicingCompanyName = invoicingCompany.NAAM.replace('&', '%26');
    if (window.confirm(`ATTENTION: This company has a separate invoicing address, this will create an invoice on ${invoicingCompanyName}`)) {
      specificUrl = `?klantnummer=${invoicingCompany.FIRNR}&klantnaam=${invoicingCompanyName}&adres=${invoicingCompany.STRAAT_NR}&postkode=${invoicingCompany.POSTNR}&woonplaats=${invoicingCompany.WOONPL}&LandID=${invoicingCompany.LandID}&btwnummer=${invoicingCompany.BTW}`;
    } else {
      confirmed = false;
    }
    if (!invoicingCompany.BTW) {
      if (window.confirm(`The company to be invoiced (${invoicingCompanyName}) has no VAT number. Do you want to continue?`)) {
        specificUrl = `?klantnummer=${invoicingCompany.FIRNR}&klantnaam=${invoicingCompanyName}&adres=${invoicingCompany.STRAAT_NR}&postkode=${invoicingCompany.POSTNR}&woonplaats=${invoicingCompany.WOONPL}&LandID=${invoicingCompany.LandID}`;
      }
    }
  } else {
    let companyName = company.NAAM.replace('&', '%26');
    specificUrl = `?klantnummer=${company.FIRNR}&klantnaam=${companyName}&adres=${company.STRAAT_NR}&postkode=${company.POSTNR}&woonplaats=${company.WOONPL}&LandID=${company.LandID}&btwnummer=${company.BTW}`;
  }

  if (!confirmed) return;

  navigate({ pathname: `/invoices/new`, search: `${specificUrl}${queryUrl}` }, { state: newLines.filter((line) => line) });
};

export const SaleToDelivery = async (sale, lines, company, lineInterface, navigate, externalAddress = null, serialNumbers = []) => {
  //tranform the lines object to adhere to the delivery lines object
  //FIXME: see how this is handled in access with the amount to deliver and the amount ordered
  //this needs some extra logic
  const machineLine =
    sale.MachineType || sale.MachineNummer
      ? {
          ...lineInterface,
          Lijnnr: null,
          aantal: null,
          VP: null,
          faktuurnr: 'new',
          produktnr: 1,
          tekstlijn: `${sale.MachineType && `Machine Type:  ${sale.MachineType}`} ${sale.MachineNummer && `N° ${sale.MachineNummer}`} `
        }
      : null;

  const serialLines = buildDeliveryNoteSerialLines(serialNumbers, lineInterface);

  const newLines = [
    {
      ...lineInterface,
      Lijnnr: null,
      aantal: null,
      VP: null,
      faktuurnr: 'new',
      produktnr: 1,
      tekstlijn: `${doc_spec['order_confirmation'].lan[languageMap[sale.TaalID]]} N° ${sale.Orderbevestigingnummer} (${String(sale.Datum).substring(0, 10)})`
    },
    machineLine,
    ...lines.map((line) => ({
      ...line,
      Lijnnr: null,
      bonnr: 'new',
      aantalbesteld: line.aantal,
      aantalgeleverd: line.aantal,
      plaats: null,
      signedoff: false,
      opbon: false,
      garantie: false
    })),
    ...serialLines
  ];

  // If external address is provided (from webshop), use it directly
  if (externalAddress) {
    const externalCompanyName = (externalAddress.company || `${externalAddress.firstName} ${externalAddress.lastName}`).replace('&', '%26');
    const landId = externalAddress.countryId || company.LandID;
    navigate(
      {
        pathname: `/delivery_notes/new`,
        search: `?klantnummer=${company.FIRNR}&klantnaam=${externalCompanyName}&TaalID=${company.TaalID}&LandID=${landId}&adres=${encode(externalAddress.street)}&postkode=${encode(
          externalAddress.zipcode
        )}&woonplaats=${encode(externalAddress.city)}&isDirty=true&linesDirty=true&OrderbevestigingID=${sale.OrderbevestigingID}&refklant=${encode(sale.RefKlant)}&refklantdatum=${
          sale.RefKlantDatum || ''
        }&externalDelivery=true`
      },
      { state: newLines.filter((line) => line) }
    );
    return;
  }

  let companyName = '';
  if (sale.LeveringKlantID) {
    //this sales order has a different delivery address
    const deliveryAddress = await getRequest(`/api/companies/${sale.LeveringKlantID}`);
    companyName = deliveryAddress.NAAM.replace('&', '%26');
    company = deliveryAddress;
  } else {
    companyName = company.NAAM.replace('&', '%26');
  }

  navigate(
    {
      pathname: `/delivery_notes/new`,
      search: `?klantnummer=${company.FIRNR}&klantnaam=${companyName}&TaalID=${company.TaalID}&LandID=${company.LandID}&adres=${company.STRAAT_NR || ''}&postkode=${company.POSTNR}&woonplaats=${
        company.WOONPL
      }&isDirty=true&linesDirty=true&OrderbevestigingID=${sale.OrderbevestigingID}&refklant=${encode(sale.RefKlant)}&refklantdatum=${sale.RefKlantDatum || ''}`
    },
    { state: newLines.filter((line) => line) }
  );
};

export const SaleToQuotation = async (lines, navigate) => {
  if (!window.confirm('💥 Do you want to create a quotation from this sale?')) return;

  const newLines = [...lines.filter((l) => l.aantal && l.VP).map((l) => ({ ...l, lineIsDirty: true, Lijnnr: null, offertenr: null }))];

  navigate({ pathname: `/quotations/new`, search: `?fromSale=true&isDirty=true&isLinesDirty=true` }, { state: newLines.filter((line) => line) });
};

export const QuotationToSale = async (quotation, lines, company, lineInterface, navigate) => {
  const machineLine =
    quotation.machinetype || quotation.machinenunner
      ? {
          ...lineInterface,
          OrderbevestigingLijnID: null,
          aantal: null,
          VP: null,
          OrderbevestigingID: 'new',
          produktnr: 1,
          tekstlijn: `${quotation.machinetype && `Machine Type:  ${quotation.machinetype}`} ${quotation.machinenunner && `N° ${quotation.machinenunner}`} `
        }
      : null;

  const newLines = [
    {
      ...lineInterface,
      OrderbevestigingLijnID: null,
      aantal: null,
      VP: null,
      OrderbevestigingID: 'new',
      produktnr: 1,
      tekstlijn: `${doc_spec['quotation'].lan[languageMap[quotation.TaalID]]} N° ${quotation.Offertenummer} (${String(quotation.datum).substring(0, 10)})`
    },
    machineLine,
    ...lines.map((line) => ({
      ...line,
      OrderbevestigingLijnID: null,
      OrderbevestigingID: 'new',
      DiscountCode: line.DiscountCode || null // Preserve discount code when transforming quotation to sale
    }))
  ];

  navigate(
    {
      pathname: `/sales/new`,
      search: `?TaalID=${company.TaalID}${quotation.LeverancierID ? `&LeverancierID=${quotation.LeverancierID}` : ''}&LandID=${company.LandID}&KlantID=${
        company.FIRNR
      }&isDirty=true&linesDirty=true&refklant=${encode(quotation.refklant)}&MachineType=${encode(quotation.machinetype)}&MachineNummer=${encode(quotation.machinenunner)}&RefKlant=${encode(
        quotation.refklant
      )}&RefKlantDatum=${quotation.refklantdatum || ''}&OfferteID=${quotation.offertenr || ''}`
    },
    { state: newLines.filter((line) => line) }
  );
};

export const QuotationDuplicate = async (quotation, lines, navigate) => {
  if (!window.confirm('💥 Do you want to duplicate this quotation?')) return;

  const newLines = [...lines.map((line) => ({ ...line, Lijnnr: null, offertenr: 'new' }))];

  navigate(
    {
      pathname: `/quotations/new`,
      search: `?duplicate=true&LandID=${quotation.LandID || ''}&klantnummer=${quotation.klantnummer}&refklant=${encode(quotation.refklant)}&TaalID=${quotation.TaalID}&refklantdatum=${
        quotation.refklantdatum || ''
      }&machinetype=${encode(quotation.machinetype)}&machinenunner=${encode(quotation.machinenunner)}&leveringstermijn=${encode(quotation.leveringstermijn)}&Angebot=${encode(
        quotation.Angebot
      )}&isDirty=true&linesDirty=true&ProjectID=${quotation.ProjectID || ''}&LeverancierID=${quotation.LeverancierID || ''}`
    },
    { state: newLines.filter((line) => line) }
  );
};

export const ProjectQuotationToSale = async (quotation, lines, acceptanceData, project, navigate) => {
  const company = await getRequest(`/api/companies/${project.firnr}`);
  if (!company) return;

  // Filter out declined optional items
  const acceptedLineIds = new Set((acceptanceData?.OptionSelections || []).filter((o) => o.Accepted).map((o) => o.QuotationLineID));
  const filteredLines = lines.filter((l) => {
    if (!l.IsOptional) return true;
    return acceptedLineIds.has(l.ID);
  });

  const btw = parseInt(company.LandID) === 300 ? 21 : 0;

  // Group lines by AreaCode → LineNumber
  const areaGroups = {};
  for (const line of filteredLines) {
    const area = line.AreaCode || 'OTH';
    if (!areaGroups[area]) areaGroups[area] = {};
    const lineNum = line.LineNumber || 0;
    if (!areaGroups[area][lineNum]) areaGroups[area][lineNum] = [];
    areaGroups[area][lineNum].push(line);
  }

  // Sort areas by configured order
  const sortedAreas = Object.keys(areaGroups).sort((a, b) => (AREAS[a]?.order || 99) - (AREAS[b]?.order || 99));

  // Lookup custom labels from AreaConfigs
  const areaConfigs = quotation.AreaConfigs || [];
  const getCustomLabel = (areaCode, lineNumber) => {
    const config = areaConfigs.find((c) => c.AreaCode === areaCode && c.LineNumber === lineNumber && !c.UnitNumber);
    return config?.CustomLabel;
  };

  const newLines = [
    {
      OrderbevestigingLijnID: null,
      aantal: null,
      VP: null,
      AP: null,
      BTW: 0,
      OrderbevestigingID: 'new',
      produktnr: 1,
      tekstlijn: `${doc_spec['quotation'].lan[languageMap[company.TaalID]] || 'Quotation'} — Project ${project.Projectnummer} v${quotation.VersionNumber}${
        quotation.VersionLabel ? ` (${quotation.VersionLabel})` : ''
      }`
    }
  ];

  for (const areaCode of sortedAreas) {
    const areaLabel = AREAS[areaCode]?.label || areaCode;

    // Area header text line
    newLines.push({
      OrderbevestigingLijnID: null,
      aantal: null,
      VP: null,
      AP: null,
      BTW: 0,
      OrderbevestigingID: 'new',
      produktnr: 1,
      tekstlijn: areaLabel
    });

    // Individual item lines (no prices) + accumulate area totals
    let areaTotalVP = 0;
    let areaTotalAP = 0;
    const lineNumbers = Object.keys(areaGroups[areaCode])
      .map(Number)
      .sort((a, b) => a - b);
    for (const lineNum of lineNumbers) {
      const items = areaGroups[areaCode][lineNum];
      for (const item of items) {
        const effectivePrice = item.DiscountPercent > 0 ? item.UnitSellingPrice * (1 - item.DiscountPercent / 100) : item.UnitSellingPrice || 0;
        areaTotalVP += (item.Quantity || 0) * effectivePrice;
        areaTotalAP += (item.Quantity || 0) * (item.UnitPurchasePrice || 0);

        const optionTag = item.IsOptional ? '[OPTION] ' : '';
        newLines.push({
          OrderbevestigingLijnID: null,
          OrderbevestigingID: 'new',
          produktnr: item.ProductID || 1,
          tekstlijn: `${optionTag}${item.Description || ''}`,
          VP: null,
          aantal: item.Quantity || 0,
          AP: null,
          BTW: 0
        });
      }
    }

    // Area total line
    newLines.push({
      OrderbevestigingLijnID: null,
      OrderbevestigingID: 'new',
      produktnr: 1,
      tekstlijn: `Total ${areaLabel}`,
      VP: Math.round(areaTotalVP * 100) / 100,
      aantal: 1,
      AP: Math.round(areaTotalAP * 100) / 100,
      BTW: btw
    });
  }

  navigate(
    {
      pathname: `/sales/new`,
      search: `?KlantID=${company.FIRNR}&TaalID=${company.TaalID}&LandID=${company.LandID}&ProjectID=${project.ID}&isDirty=true&linesDirty=true`
    },
    { state: newLines }
  );
};

export const SaleDuplicate = async (sale, lines, navigate) => {
  if (!window.confirm('💥 Do you want to duplicate this sale?')) return;

  const newLines = [...lines.map((l) => ({ ...l, lineIsDirty: true, Lijnnr: null, OrderbevestigingLijnID: null, OrderbevestigingID: 'new' }))];

  navigate(
    {
      pathname: `/sales/new`,
      search: `?duplicate=true&Aanbod=${encode(sale.Aanbod)}&TaalID=${sale.TaalID}&KlantID=${sale.KlantID}&Leveringstermijn=${encode(sale.Leveringstermijn)}&MachineNummer=${encode(
        sale.MachineNummer
      )}&Notities=${encode(sale.Notities)}&MachineType=${encode(sale.MachineType)}&RefKlant=${encode(sale.RefKlant)}&RefKlantDatum=${
        sale.RefKlantDatum || ''
      }&isDirty=true&linesDirty=true&LeverancierID=${sale.LeverancierID || ''}&ProjectID=${sale.ProjectID || ''}&FacturatieKlantID=${sale.FacturatieKlantID || ''}&KlantContactID=${
        sale.KlantContactID || ''
      }&LeveringKlantID=${sale.LeveringKlantID || ''}`
    },
    { state: newLines.filter((line) => line) }
  );
};
